import type { Nullable } from '@zaptic-external/zorm/dist/helpers/types'
import type { Flow } from '../../../shared/domain/flows/types.no-deps'
import type { SupportedLanguage } from '../../../shared/i18n/types.no-deps'
import type { AbortableRequest, Endpoint, Request, RequestArgs, Route } from '../types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/flows/translation' }

type Params = never
type Body = { flow: Flow; name?: string; language: SupportedLanguage }
type Query = never
type Output = {
    name: Nullable<string>
    flow: Flow
    originalLanguage: Nullable<string>
    targetLanguage: SupportedLanguage
}

export type GetTranslationEndpoint = Endpoint<Params, Body, Query, Output>

export const getFlowTranslationRequest = (request: Request, args: RequestArgs<GetTranslationEndpoint>) =>
    request<GetTranslationEndpoint>(route, args)

export const getFlowTranslationAbortable = (request: AbortableRequest, args: RequestArgs<GetTranslationEndpoint>) =>
    request<GetTranslationEndpoint>(route, args)
